import { useMutation, useQueryClient } from '@tanstack/react-query';
import useApiFetch from './useApiFetch';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import type { Address } from '@/types';

export type SaveAddressParams = {
  id?: number | null;
  payload: Partial<Pick<Address, 'firstName' | 'lastName' | 'address1' | 'zipCode' | 'city' | 'countryId'>> & Record<string, unknown>;
};

export function useSaveAddress() {
  const { post } = useApiFetch();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: SaveAddressParams) => {
      const endpoint = `${ApiEndpointEnum.CommerceAddressBase}/save` as unknown as ApiEndpointEnum;
      const body = JSON.stringify(id ? { id, ...payload } : payload);
      return post(endpoint, body);
    },
    onSuccess: (data: any) => {
      const addr = data as Address;
      if (addr?.id != null) {
        const id = String(addr.id);
        qc.setQueryData(['address', id], addr);
      }
      // Invalidate cart so dependent UI (like shipping methods) refreshes
      qc.invalidateQueries({ queryKey: ['cart'] }).catch(() => void 0);
    },
  });
}
